var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowButtonGoToTop
    ? _c(
        "div",
        {
          staticClass: "go-floating-area",
          staticStyle: { position: "fixed", "z-index": "1 !important" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.scrollToTop.apply(null, arguments)
            },
          },
        },
        [_vm._m(0)]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "btn go-btn-icon" }, [
      _c("i", { staticClass: "go-icon-32 go-icon-to-up" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }